import { Routes, Route } from "react-router-dom";
import Notifications from "./Notifications";
import NotificationSettings from "./NotificationSettings";

const index = () => {
	return (
		<Routes>
			<Route index element={<Notifications />} />
			<Route path='/settings' element={<NotificationSettings />} />
		</Routes>
	);
};

export default index;
